import { IconFacebook, IconLinkedin } from '@lmig/lmds-react-icons';
import { isPL } from 'Foundation/Configurations/GlobalConfiguration';

export default function SocialMedia() {
  const facebookLink = isPL()
    ? 'https://www.facebook.com/libertymutual'
    : 'https://www.facebook.com/LMISmallCommercial/';

  const linkedInLink = isPL()
    ? 'https://www.linkedin.com/company/liberty-mutual-insurance'
    : 'https://www.linkedin.com/showcase/liberty-mutual-small-commercial/';

  return (
    <>
      <a
        href={facebookLink}
        aria-label="Visit Us on Facebook"
        target="_blank"
        rel="noopener noreferrer"
        data-action="action url"
        data-icon="icon-facebook"
      >
        <IconFacebook color="blue" size="24" />
      </a>
      <a
        href={linkedInLink}
        aria-label="Visit Us on LinkedIn"
        target="_blank"
        rel="noopener noreferrer"
        data-action="action url"
        data-icon="icon-linkedIn"
      >
        <IconLinkedin color="blue" size="24" />
      </a>
    </>
  );
}
